/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';

function ComponentReciepts({ dataItem }: { dataItem: { FileName: string; FilePath: string; JobOrder: string }[] }) {
  const photos = dataItem || [];
  const photosLength = photos.length;

  return (
    <>
      <div className="pt30 underlineHeadingText textCenter">Expense Reciepts</div>
      { photos?.map((data, index) => (
        <>
          {/* <PhotosComp vesselName={data.VesselName} imageUrl={data.PhotoPath} key={data.PhotoId} photoLabel={index <= 0 ? 'Photos' : ''} /> */}
          <div className="p30">
            <div
              className="recieptsImageContainer"
            >
              {
                  data?.FilePath.length > 0
                    ? (
                      <img
                        src={data?.FilePath.startsWith('https://') ? data?.FilePath : `data:image/jpeg;base64,${data?.FilePath}`}
                        alt="Photos"
                      />
                    ) : null
                  }
            </div>
          </div>
          {index < photosLength - 1
          && <div className="page-break" />}
        </>
      ))}
    </>

  );
}

export default ComponentReciepts;
